import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Custom accordion item that expands/collapses via a pure-CSS grid-rows
// transition instead of Radix's JS height measurement (scrollHeight/
// getBoundingClientRect) — avoids forcing a synchronous layout reflow
// every time an item is toggled.
export default function FAQAccordionItem({ question, answer, link, isOpen, onToggle }) {
  return (
    <div className="rounded-2xl border border-border/30 bg-card/30 backdrop-blur-sm px-6 data-[state=open]:border-primary/30" data-state={isOpen ? 'open' : 'closed'}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-4 font-inter font-semibold text-foreground text-left hover:text-primary transition-colors py-5">
        <span>{question}</span>
        <ChevronDown className={`w-4 h-4 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-300 ease-out"
        style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}>
        <div className="overflow-hidden">
          <p className="text-sm text-muted-foreground font-inter leading-relaxed pb-5">
            {answer}
            {link && (
              <>
                {' '}
                <a href={link.href} target="_blank" rel="noopener" className="text-primary font-semibold hover:underline">
                  {link.label} →
                </a>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}